import { add } from './add';
/**
 * Inverse of add.
 * @see add
 */
export const subtract = (dateInput, amount, subtractUnit) => add(dateInput, -1 * amount, subtractUnit);
//# sourceMappingURL=subtract.js.map